import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'shared-no-data-available',
    templateUrl: './no-data-available.component.html',
    styleUrls: ['./no-data-available.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatIconModule],
})
export class NoDataAvailableComponent {
	@Input() message = 'No data available.';
}
